const styles = theme => ({
  addBuyerModal: {
    [theme.breakpoints.up('md')]: {
      width: '90%',
      maxWidth: '840px',
      maxHeight: '90vh',
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      border: 0,
    },
  },
  addBuyerModalHeader: {
    [theme.breakpoints.up('md')]: {
      borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    },
    [theme.breakpoints.down('sm')]: {
      border: 0,
    },
  },

  modalContent: {
    padding: '24px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 16px 16px 16px',
    },
  },

  errorAlertContainer: {
    width: '100%',
    marginBottom: '16px',
  },

  errorAlertMessage: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '21px',
    },
  },

  representativeContentWithMarginTop: {
    marginTop: '24px',
  },

  divider: {
    margin: '24px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 0',
    },
  },

  footer: {
    boxShadow: 'none',
    padding: 0,
  },
});

export default styles;
